<template>
  <div class="AboutUs">
    <div class="AboutUs_logo">
      <img class="AboutUs_logo_img" src="@/assets/logo_red.png" />
    </div>
    <div class="AboutUs_bottom">
      <div class="AboutUs_bottom_left">
        <div
          class="AboutUs_cooperate rem1_Size"
          v-for="(item, index) in AboutUs"
          :key="index"
        >
          <p>{{ item.title }}</p>
          <div class="AboutUs_cooperate_boxEmail">
            <span
              class="AboutUs_cooperate_email"
              v-for="(tion, indexs) in item.Cooperation"
              :key="indexs"
            >
              {{ tion }}
            </span>
          </div>
        </div>
      </div>
      <div class="AboutUs_bottom_right">
        <div class="AboutUs_cooperate">
          <p>微信公众号</p>
          <img class="QR_Code_image" src="@/assets/QR_Code.jpg" />
        </div>
        <div class="AboutUs_cooperate">
          <a href="/PrivacyPolicy">隐私政策</a>
        </div>
      </div>
    </div>
    <div class="AboutUs_a">
      <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2025373359号-1</a>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      AboutUs: [
        {
          title: "商务合作",
          Cooperation: [
            "联系方式：15172485886",
            "Email：zhangchengxinglenn@163.com",
          ],
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: none; /* 去掉下划线 */
  color: inherit; /* 颜色继承父元素 */
  outline: none; /* 去掉点击链接时的轮廓 */
  border: none; /* 去掉可能的边框 */
}
@media (min-width: 768px) {
  .AboutUs {
    width: 100%;
    height: 288px;
    background-color: #161617;
    // display: flex;
    color: #fff;
    padding: 20px 40px;
    .AboutUs_logo {
      width: 155px;
      height: 47.5px;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden; /* 防止图片溢出 */
      .AboutUs_logo_img {
        width: 100%; /* 宽度适应容器 */
        // transform: rotateZ(270deg) scale(1.5);
      }
    }
    .AboutUs_bottom {
      width: 100%;
      display: flex;
      justify-content: center;
      .AboutUs_bottom_left {
        flex: 2;
        display: flex;
        justify-content: left;
        .AboutUs_cooperate {
          flex: 1;
          height: 100%;
          padding: 20px 0;
          margin-left: 78px;
          display: flex;
          // align-items: flex-end;
          align-items: flex-start;
          // justify-content: right;
          flex-direction: column;
          .AboutUs_cooperate_boxEmail {
            margin-top: 16px;
            .AboutUs_cooperate_email {
              margin-right: 10px;
            }
            .AboutUs_cooperate_email:hover {
              color: #cc0a42;
            }
          }
        }
        .AboutUs_cooperate p {
          cursor: pointer;
        }
      }
      .AboutUs_bottom_right {
        flex: 1;
        display: flex;
        .AboutUs_cooperate {
          flex: 1;
          height: 100%;
          padding: 20px 0;
          display: flex;
          align-items: center;
          flex-direction: column;
          .QR_Code_image {
            width: 98px;
            height: 98px;
            margin-top: 16px;
          }
        }
      }
    }
    .AboutUs_a {
      width: 100%;
      display: flex;
      justify-content: center;
      font-size: 0.8rem;
    }
  }
}
@media (max-width: 768px) {
  .AboutUs {
    width: 100%;
    height: auto;
    background-color: #161617;
    color: #fff;
    .AboutUs_logo {
      width: 100%;
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden; /* 防止图片溢出 */
      .AboutUs_logo_img {
        height: 100%;
      }
    }
    .AboutUs_bottom {
      width: 100%;
      height: 100%;
      .AboutUs_bottom_left {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;
        .AboutUs_cooperate {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          flex-direction: column;
          .AboutUs_cooperate_boxEmail {
            display: flex;
            align-items: center;
            flex-direction: column;
            margin-top: 5px;
            .AboutUs_cooperate_email {
              margin-top: 5px;
            }
            .AboutUs_cooperate_email:hover {
              color: #cc0a42;
            }
          }
        }
        .AboutUs_cooperate p {
          cursor: pointer;
        }
      }
      .AboutUs_bottom_right {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;
        .AboutUs_cooperate {
          width: 100%;
          height: 100%;
          padding: 20px 0;
          display: flex;
          align-items: center;
          flex-direction: column;
          .QR_Code_image {
            width: 98px;
            height: 98px;
            margin-top: 16px;
          }
        }
      }
    }
    .AboutUs_a {
      width: 100%;
      display: flex;
      justify-content: center;
      font-size: 0.8rem;
    }
  }
}
</style>
